import React from 'react'
import { AddChatPromptProps } from 'chats/interfaces'
import ChatPrompt from './ChatPrompt'

export const AddChatPrompt = (props: AddChatPromptProps) => {
  return <ChatPrompt {...props} isNew={true} name="" description="" />
}

export default AddChatPrompt
